import { THUNK_STATUS } from "@duosoftbg/nacid-components";
import { initialAdditionalDocApplicantDetails } from "./common/applicantDetailsInitialValues";
import { initialDocumentDetails } from "./common/documentInitialValues";
import React from "react";
import { AdditionalDocApplication, AdditionalDocCommonDetails } from "../types/additionalDocTypes";
import RudiAdditionalDocStepApplicant from "../views/components/services/additionalDoc/form/applicant/RudiAdditionalDocStepApplicant";
import RudiAdditionalDocStepDocuments from "../views/components/services/additionalDoc/form/documents/RudiAdditionalDocStepDocuments";
import RudiAdditionalDocStepFiling from "../views/components/services/additionalDoc/form/filing/RudiAdditionalDocStepFiling";
import RudiAdditionalDocStepDetails from "../views/components/services/additionalDoc/form/detail/RudiAdditionalDocStepDetails";

export const initialAdditionalDocDetail: AdditionalDocCommonDetails = {
  entryNumber: "",
  additionalInfo: "",
};

export const initialRudiAdditionalDocApplication: AdditionalDocApplication = {
  additionalDocDetail: initialAdditionalDocDetail,
  dataStateStatus: THUNK_STATUS.INITIAL,
  applicantDetails: initialAdditionalDocApplicantDetails,
  documentDetails: initialDocumentDetails,
  steps: [
    {
      labelCode: "l.step.applicant",
      completed: false,
      component: <RudiAdditionalDocStepApplicant />,
      isEdited: false,
    },
    {
      labelCode: "l.step.additionalDoc.details",
      completed: false,
      component: <RudiAdditionalDocStepDetails />,
      isEdited: false,
    },
    {
      labelCode: "l.step.attachments",
      completed: false,
      component: <RudiAdditionalDocStepDocuments />,
      isEdited: false,
    },
    {
      labelCode: "l.step.filing",
      completed: false,
      component: <RudiAdditionalDocStepFiling />,
      isEdited: false,
    },
  ],
};
